import React, { useEffect, useState, useCallback } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Heart, Star, Cookie } from "lucide-react";

let idc = 0;

const ICONS = {
  heart: (s) => <Heart className="fill-pusheen-pink text-pusheen-pink" style={{ width: s, height: s }} />,
  star: (s) => <Star className="fill-white text-white" style={{ width: s, height: s }} />,
  cookie: (s) => <Cookie className="text-[#c98a3d] fill-[#e6b56b]" style={{ width: s, height: s }} />,
};

export default function ParticleLayer() {
  const [parts, setParts] = useState([]);

  const spawn = useCallback((detail) => {
    const { x, y, count = 12, kinds = ["heart", "star"], spread = 160, up = 220 } = detail;
    const batch = [];
    for (let i = 0; i < count; i++) {
      const kind = kinds[Math.floor(Math.random() * kinds.length)];
      batch.push({
        id: ++idc,
        x,
        y,
        dx: (Math.random() - 0.5) * spread * 2,
        dy: -(Math.random() * up + 60),
        rot: (Math.random() - 0.5) * 220,
        size: 16 + Math.random() * 22,
        kind,
      });
    }
    setParts((p) => [...p, ...batch]);
    setTimeout(() => {
      const ids = new Set(batch.map((b) => b.id));
      setParts((p) => p.filter((x) => !ids.has(x.id)));
    }, 1400);
  }, []);

  useEffect(() => {
    const h = (e) => spawn(e.detail || {});
    window.addEventListener("pusheen-burst", h);
    return () => window.removeEventListener("pusheen-burst", h);
  }, [spawn]);

  return (
    <div className="pointer-events-none fixed inset-0 z-[60] overflow-hidden" aria-hidden="true">
      <AnimatePresence>
        {parts.map((p) => (
          <motion.div
            key={p.id}
            initial={{ x: p.x, y: p.y, opacity: 1, scale: 0.4, rotate: 0 }}
            animate={{ x: p.x + p.dx, y: p.y + p.dy, opacity: 0, scale: 1.1, rotate: p.rot }}
            transition={{ duration: 1.2, ease: "easeOut" }}
            className="absolute left-0 top-0"
            style={{ marginLeft: -p.size / 2, marginTop: -p.size / 2 }}
          >
            {ICONS[p.kind](p.size)}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
